module.exports = __webpack_public_path__ + "img/mypage.5be07757.png";